import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, of, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { Guid } from "typescript-guid";
import { ConfigurationService } from "../../services/configuration.service";

@Injectable()
export class ConfigurationExistsGuard implements CanActivate {
  constructor(private configurationService: ConfigurationService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const id = route.paramMap.get("instance-id");
    if (Guid.isGuid(id)) {
      return this.configurationService.getById(id).pipe(
        map((configuration) => !!configuration),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401 || error.status === 403) {
            return throwError(error);
          }
          const errorMessage = `Configuration Id '${id}' does not exist in tenant or has already been deleted.`;
          this.router.navigate(["/", "error"], { queryParams: { detail: errorMessage } });
          return of(false);
        })
      );
    } else {
      const errorMessage = `Configuration Id '${id}' is invalid.`;
      this.router.navigate(["/", "error"], { queryParams: { detail: errorMessage } });
      return of(false);
    }
  }
}
